import React, { useRef, useState } from "react";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../style.scss";
import * as yup from "yup";
import { useFormik } from "formik";
import PreviewImage from "../../../Component/previewImage";
import { apiAdminConfig } from "../../../utils/api";
import useToast from "../../../provider/Toast/useToast";
import { PDFBox } from "../../../Component/form";
import MultiPDFBox from "../../../Component/form/multiPdfUpload";
import PreviewPDF from "../../../Component/previewPDF";

const EditCertificates = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const fileRef = useRef(null);
  const [fileError, setFileError] = useState(false);
  const [doctors, setDoctors] = React.useState([]);
  const toast = useToast();
  const getCertificate = async () => {
    await apiAdminConfig.get('admin/getdoctors').then((response) => {
      if (response?.data?.status) {
        let DoctorsData = [];
        response?.data?.data.forEach((element) => {
          if (element.isApproved === "APPROVED") {
            DoctorsData.push(element)
          }
        })
        setDoctors(DoctorsData)
      }
    }).catch((error) => {
      // const { response } = error;
      console.log("certificateError", error);
    })
  };

  React.useEffect(() => {
    getCertificate();
  }, []);


  const validationSchema = yup.object().shape({
    docId: yup.string().required("Select Member a required"),
  });

  const { handleSubmit, handleChange, setFieldValue, values, errors, touched } =
    useFormik({
      initialValues: {
        files: [],
        docId: "",
      },
      validationSchema,
      onSubmit: async () => {
        if (values?.files?.length > 0) {
          await apiAdminConfig.put(`admin/certificate/${id}`, { files: values?.files }).then((response) => {
            if (response?.data.status) {
              navigate('/certificates')
              toast({
                message: response?.data?.message,
                bg: 'success'
              });
            } else {
              toast({
                message: response?.data?.message,
                bg: 'danger'
              });
            }
          }).catch((error) => {
            const { response } = error;
            console.log("eventError", error)
            toast({
              message: response?.data?.message,
              bg: "danger",
            });
          })
        } else {
          setFileError(true)
        }
      },
    });

  const bindData = async (id) => {
    await apiAdminConfig.get(`admin/certificategetById/${id}`).then((response) => {
      if (response?.data?.status === true) {
        const { data } = response?.data;
        for (const [key] of Object.entries(values)) {
          if (key === "docId") {
            setFieldValue("docId", data?.docId?._id)
          } else {
            setFieldValue([key], data[key])
          }
        }
      }
    }).catch((error) => {
      console.log('EventError', error);
    })
  }
  React.useEffect(() => {
    if (id) {
      bindData(id);
    }
  }, [id]);

  return (
    <main id="events">
      <Container className="admin_padding">
        <div className="admin_add_form">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "14px 0",
              alignItems: "center",
            }}
            className="table-hader-container"
          >
            <div>
              <h3 className="table-hader-name">Edit Certificate</h3>
            </div>
            <Link to="/certificates" className="page_add_btn">
              Back
            </Link>
          </div>
          <Row>
            <Col>
              <Form noValidate onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <MultiPDFBox
                        url="imageUpload/certificate"
                        // accept="application/pdf"
                        accept="application/pdf, image/*"
                        name="url"
                        label="ADD CERTIFICATE FILE"
                        fileError={fileError}
                        setFileError={setFileError}
                        error={!!errors.url &&
                          touched.url && errors.url}
                        value={values?.url}
                        onChange={(e) => {
                          let filesData = values?.files ?? []
                          setFieldValue("files", [...filesData, ...e])
                        }}
                        uploadText="Upload Certificate PDF/image"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Col>
                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px'
                      }}>
                        {values?.files?.length > 0 ? values?.files?.map(list => (
                          <PreviewPDF file={list?.url} isDelete={true} id={list?._id ?? ''} setFieldValue={setFieldValue} values={values} />
                        )) : null}
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        SELECT MEMBER<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        disabled
                        type="text"
                        name="docId"
                        value={values.docId}
                        onChange={(e) => {
                          setFieldValue("docId", e.target.value)
                        }}
                        isInvalid={!!errors.docId && touched.docId}
                      >
                        <option>Select Member</option>
                        {doctors && doctors.length > 0 && doctors.map((item, index) => {
                          return (
                            <option value={item?._id} key={`doctors-${index}`}>{item?.title}</option>
                          )
                        })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.docId}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="footer-btns"
                >
                  <Button type="submit" className="input_file_button">
                    Publish
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </main>
  );
};

export default EditCertificates;
